import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@mui/material/SvgIcon';

const IconFavoriteOutline = (props) => {
  const { titleAccess, ...rest } = props;
  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <SvgIcon {...rest} width="36px" height="36px" viewBox="0 0 36 36">
      {titleAccess && <title>{titleAccess}</title>}
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(1.926, 1.8838)" stroke="currentColor" strokeWidth="3">
          <path d="M15.97674,31.998911 L16.0232601,31.998911 C15.801534,32.0069355 15.6149218,31.971045 15.4892166,31.8769077 C9.14377526,27.1256907 2.925469,22.1478943 0.514560693,13.8464702 C-0.909885397,8.94165189 0.724233839,3.75882205 4.16819837,1.37904341 C7.55625006,-0.961813629 11.3004133,-0.326557297 15.6423113,3.31539366 C15.7536153,3.40874309 15.8955381,3.46259851 16.0025632,3.49969329 C16.1055834,3.46217216 16.2468246,3.40837411 16.3576886,3.31539366 C20.6995867,-0.326557297 24.4437499,-0.961813629 27.8318017,1.37904341 C31.2757662,3.75882205 32.9098854,8.94165189 31.4854393,13.8464702 C29.074531,22.1478943 22.8562247,27.1256907 16.5107833,31.8769077 C16.3850782,31.971045 16.1984661,32.0069355 15.97674,31.998911 L16.0232601,31.998911 L15.97674,31.998911 Z" />
        </g>
      </g>
    </SvgIcon>
  );
};

IconFavoriteOutline.propTypes = {
  titleAccess: PropTypes.string,
};

IconFavoriteOutline.defaultProps = {
  titleAccess: '',
};

export default IconFavoriteOutline;
